module.exports = __webpack_public_path__ + "assets/img/3-1.85b0f202.jpg";